import { render, staticRenderFns } from "./AlignImage.vue?vue&type=template&id=7b6825a9"
import script from "./AlignImage.vue?vue&type=script&lang=js"
export * from "./AlignImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports